import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { AppRoutingModule, routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ApiInterceptor } from './core/interceptor/api.interceptor';
import { CommonDataService } from './core/services/common-data.service';
import { AuthService } from './core/services/auth.service';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { CookieService } from 'ngx-cookie-service'


// export function loadConfig(authService: AuthService, http: HttpClient) {
//   return () =>
//     new Promise((resolve, reject) => {
//       const token = localStorage.getItem('access_token'); // Or use TokenService
//       if (!token) {
//         console.warn('No access token found, skipping profile load.');
//         return resolve(true);
//       }

//       authService.getMyProfile().subscribe(
//         (profile) => {
//           console.log('Profile Loaded:', profile);
//           resolve(true);
//         },
//         (error) => {
//           console.error('Profile Load Failed:', error);
//           resolve(true); // Resolve even if it fails
//         }
//       );
//     });
// }



export const appConfig: ApplicationConfig = {
  providers: [
    CookieService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // provideHttpClient(),
    provideToastr(),
    // provideReactiveForms(),
    provideAnimations(),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    LoaderComponent,
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: loadConfig,
    //   deps: [AuthService,CommonDataService, HttpClient],
    //   multi: true
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    }
  ]
};
